import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import {Link} from "react-router-dom";

const HeaderResponsive = () => {
    return (
        <div
            className="login-header-responsive d-flex d-lg-none justify-content-center align-items-center flex-column"
            style={{backgroundImage: "url('./assets/vendorImages/sayman-pattern-3.png')"}}>
            <h2 className="header-responsive-title">ورود به مرکز فروشندگان</h2>
            <div className="logo">
                <Link to="/"> <IconName name="sayman-logo" className="icon"/></Link>
            </div>
        </div>
    );
};

export default HeaderResponsive;
